import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

const Main = () => (
  <>
    {process.env.NODE_ENV === 'development' ? (
      <React.StrictMode>
        <App />
      </React.StrictMode>
    ) : (
      <App />
    )}
  </>
);

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <Main />
);
